module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-grouping text-dark"
  }, [_c('div', {
    staticClass: "d-grouping__header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.tagging.tagging_users')))]), _vm._v(" "), _c('div', {
    staticClass: "d-grid-table"
  }, [_c('div', {
    staticClass: "d-grid-table__column d-grid-table__column-1"
  }, [_c('div', {
    staticClass: "d-grid-table__column-header"
  }, [_vm._v("\n          " + _vm._s(_vm.i18n['groups']) + "\n        ")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "tags-li__create"
  }, [_c('button', {
    staticClass: "btn btn-trans",
    on: {
      "click": function($event) {
        return _vm.setIsModal(true)
      }
    }
  }, [_vm._v("\n              + " + _vm._s(_vm.i18n['create_a_new_group']) + "\n            ")])]), _vm._v(" "), _c('li', {
    class: {
      'filter--active': !_vm.activeTag
    },
    on: {
      "click": function($event) {
        return _vm.setActiveTag(null)
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.i18n['all']))]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v("\n              " + _vm._s(_vm.usersSortedOnName.length) + "\n            ")])]), _vm._v(" "), _vm._l((_vm.tagsWithProps), function(tag) {
    return _c('li', {
      key: tag.v_name,
      ref: "droppable_elements",
      refInFor: true,
      staticClass: "tag-filter",
      class: [{
        'filter--active': _vm.activeTag === tag.v_name
      }],
      on: {
        "click": function($event) {
          return _vm.setActiveTag(tag.v_name)
        },
        "dragover": function($event) {
          $event.preventDefault();
        },
        "dragenter": function($event) {
          $event.preventDefault();
          return _vm.dragEnter(tag, $event)
        },
        "dragleave": function($event) {
          $event.preventDefault();
          return _vm.dragLeave.apply(null, arguments)
        },
        "drop": function($event) {
          $event.preventDefault();
          return _vm.drop(tag, $event)
        }
      }
    }, [_c('div', {
      staticClass: "tags-li__left"
    }, [_c('DDropdown', [_c('ul', {
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.setTheEditTag(tag)
        }
      }
    }, [_c('span', {
      staticClass: "icon-pencil"
    }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.rename')) + "\n                  ")]), _vm._v(" "), _c('li', {
      staticClass: "d-item-warning",
      on: {
        "click": function($event) {
          return _vm.setTheDeleteTag(tag)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    }), _vm._v("\n                    " + _vm._s(_vm.$t('vue2.common.delete')) + "\n                  ")])])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(tag.v_name))])], 1), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "icon-user"
    }), _vm._v("\n              " + _vm._s(tag.v_number_of_persons) + "\n            ")])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-grid-table__column d-grid-table__column-3"
  }, [_c('div', {
    staticClass: "d-grid-table__column-header"
  }, [_c('div', {
    staticClass: "d-grid-table__column-header__left"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.users')) + "\n            "), (_vm.activeTag) ? [_vm._v(" " + _vm._s(_vm.i18n['in_the_group']) + ": "), _c('span', {
    staticClass: "icon-price-tag2 marg-5-right marg-1-left"
  }), _vm._v(_vm._s(_vm.activeTag) + "\n            ")] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "d-grid-table__column-header__right"
  }, [_c('div', [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "isSmall": true,
      "bg-color": "#f6f9fc"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeTag) ? _c('DSelect', {
    staticClass: "marg-1-left",
    attrs: {
      "items": _vm.usersForDSelect,
      "itemsSelected": [],
      "placeholder": _vm.$t('vue2.common.add_user'),
      "showSelectedUsers": false
    },
    on: {
      "add": function($event) {
        return _vm.addUserToTag($event)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "users-list-header"
  }, [_c('span', {
    staticClass: "text-link",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.usersSelectedForDrag.length < 1) ? [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))] : [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))]], 2)]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('li', {
      key: user.id,
      staticClass: "user-in-list",
      class: {
        'isSelected': user.v_isSelectedForDrag
      },
      attrs: {
        "draggable": "true"
      },
      on: {
        "dragover": function($event) {
          $event.stopPropagation();
        },
        "dragstart": function($event) {
          $event.stopPropagation();
          return _vm.dragStart(user, $event)
        },
        "dragend": function($event) {
          $event.stopPropagation();
          return _vm.dragEnd(user, $event)
        },
        "drop": function($event) {
          $event.preventDefault();
          return _vm.drop(user, $event)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          boundary: 'window',
          arrow: false,
          placement: 'left-start'
        }),
        expression: "{boundary: 'window', arrow: false, placement : 'left-start'}"
      }],
      staticClass: "user-in-list__left",
      attrs: {
        "content": _vm.i18n['drag_and_drop_explained']
      }
    }, [_c('svg', {
      staticStyle: {
        "enable-background": "new 0 0 572.156 572.156"
      },
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        "version": "1.1",
        "id": "Capa_1",
        "x": "0px",
        "y": "0px",
        "width": "13px",
        "height": "13px",
        "viewBox": "0 0 572.156 572.156",
        "xml:space": "preserve"
      }
    }, [_c('g', [_c('polygon', {
      attrs: {
        "points": "495.405,241.769 418.657,197.457 418.657,258.115 314.042,258.115 314.042,153.498 374.699,153.498    330.389,76.751 286.078,0 241.769,76.751 197.457,153.498 258.115,153.498 258.115,258.115 153.498,258.115 153.498,197.457    76.751,241.767 0,286.078 76.751,330.387 153.498,374.699 153.498,314.042 258.115,314.042 258.115,418.657 197.457,418.657    241.767,495.405 286.078,572.156 330.387,495.405 374.699,418.657 314.042,418.657 314.042,314.042 418.657,314.042    418.657,374.699 495.405,330.389 572.156,286.078  "
      }
    })]), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')]), _vm._v(" "), _c('div', {
      staticClass: "icon__bg-circle",
      on: {
        "click": function($event) {
          return _vm.setUsersSelectedForDrag(user)
        }
      }
    }, [_c('div', {
      staticClass: "d-checkbox",
      class: {
        'd-checkbox--active': false
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(user.name))])]), _vm._v(" "), _c('div', {
      staticClass: "user-tags"
    }, _vm._l((user.user_tags), function(tag) {
      return _c('div', {
        staticClass: "d-tag"
      }, [_c('div', {
        staticClass: "d-tag__text"
      }, [_vm._v(_vm._s(tag))]), _vm._v(" "), _c('div', {
        staticClass: "icon-cross2 d-tag__icon",
        on: {
          "click": function($event) {
            return _vm.deleteTagFromUser(user, tag)
          }
        }
      })])
    }), 0)])
  })], 2)])])]), _vm._v(" "), (_vm.isModal) ? _c('DModal', {
    attrs: {
      "showClose": false,
      "is-bg-overlay": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [(!_vm.theEditTag && !_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['create_group']))]) : _vm._e(), _vm._v(" "), (_vm.theEditTag && !_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['edit_group']))]) : _vm._e(), _vm._v(" "), (_vm.theDeleteTag) ? _c('span', [_vm._v(_vm._s(_vm.i18n['delete_group']))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "role-modal__close icon__bg-circle",
    on: {
      "click": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body"
  }, [(!_vm.theDeleteTag) ? _c('div', {
    staticClass: "d-input-group marg-1-bottom"
  }, [_c('label', {
    staticClass: "d-label marg-5-bottom"
  }, [_vm._v(_vm._s(_vm.i18n['name_for_group']))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.tagTitle),
      expression: "tagTitle",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.tagTitle)
    },
    on: {
      "change": function($event) {
        _vm.tagTitle = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteTag && !_vm.theEditTag) ? _c('div', {
    staticClass: "d-input-group marg-2-bottom"
  }, [_c('label', {
    staticClass: "d-label marg-5-bottom"
  }, [_vm._v(_vm._s(_vm.i18n['select_a_user']))]), _vm._v(" "), _c('DSelectUsers', {
    on: {
      "update": _vm.setSelectedUsers
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "marg-10-right",
    on: {
      "click": function($event) {
        return _vm.setIsModal(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), (!_vm.theEditTag && !_vm.theDeleteTag) ? _c('button', {
    staticClass: "submit-button",
    class: [{
        'submit-button--disabled': _vm.tagTitle.length < 1 || _vm.selectedUserIds.length === 0
      },
      {
        'submit-button--loading': _vm.isButtonLoading
      }
    ],
    on: {
      "click": _vm.createTag
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.create')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theEditTag) ? _c('button', {
    staticClass: "submit-button",
    class: [{
        'submit-button--disabled': _vm.tagTitle.length < 1
      },
      {
        'submit-button--loading': _vm.isButtonLoading
      }
    ],
    on: {
      "click": _vm.editTag
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.save')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.theDeleteTag) ? _c('button', {
    staticClass: "submit-button submit-button--danger",
    class: {
      'submit-button--loading': _vm.isButtonLoading
    },
    on: {
      "click": _vm.deleteTag
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.common.delete')) + "\n          ")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "customdrag",
    staticClass: "d-custom-drag",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.i18n['add']) + " " + _vm._s(_vm.usersSelectedForDrag.length) + "\n    "), (_vm.usersSelectedForDrag.length === 1) ? [_vm._v(" " + _vm._s(_vm.$t('vue2.common.user')))] : [_vm._v(" " + _vm._s(_vm.$t('vue2.common.users')))]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f17a134!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tagging/Tagging.vue
// module id = 1541
// module chunks = 1